import {useQuery} from 'react-query';

export function isGeolocationDenied(error: any) {
  return (
    (error as GeolocationPositionError).code ===
    GeolocationPositionError.PERMISSION_DENIED
  );
}

//geolocationError will occur when permission is denied
//this is more reliable than explicitly checking for it - moden browsers mask the state as 'prompt' when queried
//so better to try and ask for forgiveness
export function useGeolocation() {
  return useQuery(
    ['geolocation'],
    async () =>
      new Promise<GeolocationCoordinates>((resolve, reject) => {
        if ('geolocation' in window.navigator) {
          window.navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve(position.coords);
            },
            (err: GeolocationPositionError) => {
              reject(err);
            },
          );
        } else {
          reject('Geolocation not available');
        }
      }),
  );
}

//Don't use this - see above
export const useHasLocationPermission = () =>
  useQuery(['has-location-permissions'], async () => {
    if (!navigator) {
      return false;
    }

    const {state} = await navigator.permissions.query({name: 'geolocation'});
    return state !== 'denied';
  });
